module.exports = __webpack_public_path__ + "img/metal_an@2x.4e0a6e7d.png";